import LINKS from 'app/const/links';


const createSocialUrl = (options, link) => {
    const {
        url = '/',
        queryParams,
    } = options;

    const query = Object.entries(queryParams)
        .map(([key, value]) => {
            const isValueFunction = typeof value === 'function';
            const val = isValueFunction ? value(link) : value;
            return `${key}=${val}`;
        })
        .join('&');

    return `${url}?${query}`;
};


const { TRIAL_FIRST_ORDER_SET } = LINKS;

const img = encodeURIComponent(`${window.location.origin}/link-preview/sharing-by-ref.jpg`);


const TITLE = 'Всем вкусной еды дома! Elementaree привозит продукты '
    + 'и чистит картошку за меня, а я дарю скидку на первый заказ по этой ссылке';


const fbOptions = {
    url: 'https://www.facebook.com/sharer.php',
    queryParams: {
        u: (link) => encodeURIComponent(link),
        quote: encodeURIComponent(TITLE),
        // picture: img, // не работает
    },
};

const vkOptions = {
    url: 'https://vk.com/share.php',
    queryParams: {
        url: (link) => encodeURIComponent(link),
        title: encodeURIComponent(TITLE),
        image: img,
    },
};

const tgOptions = {
    url: 'https://telegram.me/share/url',
    queryParams: {
        url: (link) => encodeURIComponent(link),
        text: encodeURIComponent(TITLE),
        // image: img,
    },
};

const tgAppOptions = {
    url: 'tg://msg_url',
    queryParams: {
        url: (link) => encodeURIComponent(link),
        text: encodeURIComponent(TITLE),
        // image: img,
    },
};

const okParams = {
    url: 'https://connect.ok.ru/offer/',
    queryParams: {
        url: (link) => encodeURIComponent(link),
        title: encodeURIComponent(TITLE),
        imageUrl: img,
    },
};


// export const referalLink = code => `${window.location.origin}${TRIAL_FIRST_ORDER_SET.hrefReferal}&eeref=${code}`;
export const referalLink = (code) => `${window.location.origin}${TRIAL_FIRST_ORDER_SET.hrefReferal}&eeref=${code}`;

export const getFbLink = (link) => createSocialUrl(fbOptions, link);
export const getVkLink = (link) => createSocialUrl(vkOptions, link);
export const getTgLink = (link) => createSocialUrl(tgOptions, link);
export const getTgAppLink = (link) => createSocialUrl(tgAppOptions, link);
export const getOkLink = (link) => createSocialUrl(okParams, link);
